// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// // import AdSenseAd from "../JobDetails/AdsenseAd";

// const RedirectPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [timeLeft, setTimeLeft] = useState(15);

//   // countdown
//   useEffect(() => {
//     if (timeLeft === 0) return;

//     const timer = setTimeout(() => {
//       setTimeLeft((prev) => prev - 1);
//     }, 1000);

//     return () => clearTimeout(timer);
//   }, [timeLeft]);

//   // auto redirect (optional)
//   useEffect(() => {
//     if (timeLeft === 0) {
//       // comment this if you want button instead
//       // navigate(`/${id}`);
//     }
//   }, [timeLeft, id, navigate]);

//   return (
//     <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 px-4">

//       <h2 className="text-2xl font-semibold mb-6 text-gray-800 text-center">
//         Your link will be ready in{" "}
//         <span className="text-blue-600 text-3xl">{timeLeft}</span> seconds
//       </h2>

//       {/* 🔥 AdSense Ad */}
//       {/* <div className="my-6 w-full max-w-md">
//         <AdSenseAd
//           client="ca-pub-2161842895850825"
//           slot="2033357033"
//           format="auto"
//           responsive="true"
//         />
//       </div> */}

//       {/* Button after countdown */}
//       {timeLeft === 0 && (
//         <button
//           onClick={() => navigate(`/${id}`)}
//           className="px-10 py-4 bg-blue-600 text-white text-lg rounded-xl shadow-lg hover:bg-blue-700 transition"
//         >
//           Click Here
//         </button>
//       )}
//     </div>
//   );
// };

// export default RedirectPage;
import React from 'react'

const RedirectPage = () => {
  return (
    <div>RedirectPage</div>
  )
}

export default RedirectPage